import { DEGREES_OF_FREEDOM_SPEC } from "./newAdCreateHelpers"


// Mapping of all supported placement types for each platform
const PLATFORM_POSITIONS = {
  facebook: ["feed", "right_hand_column", "marketplace", "video_feeds", "search", "story", "instream_video", "profile_feed", "facebook_reels_overlay", "facebook_reels"],
  instagram: ["stream", "story", "explore", "explore_home", "profile_feed", "ig_search", "reels"],
}


const CLUBED_POSITIONS = [
  {
    creativeType: "fb_feed_creative", 
    positionTypes: ["feed", "instream_video", "facebook_reels_overlay", "marketplace", "video_feeds", "profile_feed", "right_hand_column", "search"]
    },
    {
      creativeType: "fb_reels_creative",
      positionTypes: ["story", "facebook_reels"]
    },
    {
      creativeType: "insta_feed_creative",
      positionTypes: ["stream", "explore", "explore_home", "profile_feed",  "ig_search"]
    },
    {
      creativeType: "insta_reels_creative",
      positionTypes: ["story", "reels"]
    }
]

const imageCustomizationRules = [
  {
    "customization_spec": {
      "publisher_platforms": [
        "facebook"
      ],
      "facebook_positions": [
        "feed",
        "instream_video",
        "facebook_reels_overlay",
        "marketplace", 
        "video_feeds",
        "profile_feed",
        "right_hand_column",
        "search"
      ]
    },
    "image_label": {
      "name": "fb_feed_label"
    },
    "body_label": {
      "name": "body_copy_label"
    },
    "title_label": {
      "name": "title_copy_label"
    }
  },
  {
    "customization_spec": {
      "publisher_platforms": [
        "instagram"
      ],
      "instagram_positions": [
        "story",
        "reels"
      ]
    },
    "image_label": {
      "name": "insta_story_label"
    },
    "body_label": {
      "name": "body_copy_label"
    },
    "title_label": {
      "name": "title_copy_label"
    }
  },
  {
    "customization_spec": {
      "publisher_platforms": [
        "facebook"
      ],
      "facebook_positions": [
        "story",
        "facebook_reels"
      ]
    },
    "image_label": {
      "name": "fb_reels_label"
    },
    "body_label": {
      "name": "body_copy_label"
    },
    "title_label": {
      "name": "title_copy_label"
    }
  },
  {
    "customization_spec": {
      "publisher_platforms": [
        "instagram"
      ],
      "instagram_positions": [
        "stream", 
        "explore",
        "explore_home", 
        "profile_feed", 
        "ig_search"
      ]
    },
    "image_label": {
      "name": "insta_feed_label"
    },
    "body_label": {
      "name": "body_copy_label"
    },
    "title_label": {
      "name": "title_copy_label"
    }
  }
]

/**
 * Create payload for multi-placement image ad creative.
 *
 * @param {Object} params
 * @param {string} params.name - Name of the ad creative.
 * @param {Array} params.bodies - Array of body objects.
 * @param {Array} params.titles - Array of title objects.
 * @param {string} params.pageId - Facebook page id.
 * @param {string} params.instagramActorId - Instagram actor id.
 * @param {Array} params.creatives - Array of creative objects from the ad.
 *        Each creative is expected to contain at least a property for
 *        image hash (facebookImageHash) or a URL.
 * @param {string} params.callToActionType - Call to action type.
 * @param {string} params.callToActionLink - Call to action link.
 *
 * @returns {Object} - JSON payload to create an image ad creative.
 */
export function createMultiPlacementImageAdCreativePayload({
  name,
  bodies,
  titles,
  pageId,
  instagramActorId,
  creatives,
  callToActionType,
  callToActionLink,
  trackingTemplate=null,
  deepLink=null
}) {

  let images = []
  let videos = []
  const ad_formats = ["SINGLE_IMAGE"]

  // Loop through the creatives array
  for (let i = 0; i < creatives.length; i++) {
    const creative = creatives[i];

    // Add multiple elements based on a condition
    if (creative.positionType === "feed") {
      images.push({
        adlabels: [{ name: "fb_feed_label" }],
        url: creative.previewLink,
      });
      images.push({
        adlabels: [{ name: "insta_feed_label" }],
        url: creative.duplicateUrl,
      });
    }
    if (creative.positionType === "story") {
      images.push({
        adlabels: [{ name: "fb_reels_label" }],
        url: creative.previewLink,
      });
      images.push({
        adlabels: [{ name: "insta_story_label" }],
        url: creative.duplicateUrl,
      });
    }
  }
  console.log("len of images:", images.length)

  // Create the payload
  let payload = {
    name: name,
    ...(trackingTemplate && { url_tags: trackingTemplate }),
    object_story_spec: {
      page_id: pageId,
      instagram_user_id: instagramActorId,
    },

    degrees_of_freedom_spec: DEGREES_OF_FREEDOM_SPEC,

    asset_feed_spec: {
      images,
      videos,
      bodies,
      titles,
      call_to_action_types: [callToActionType],
      link_urls: [
        {
          website_url: callToActionLink,
          display_url: callToActionLink,
          ...(deepLink && { deeplink_url: deepLink }),
        },
      ],
      ad_formats,
      // asset_customization_rules: getAssetCustomizationRules(ad),
      asset_customization_rules: imageCustomizationRules,
    },
  }  
  return payload;
}


const videoCustomizationRules = [
  {
      "customization_spec": {
          "publisher_platforms": [
              "instagram"
          ],
          "instagram_positions": [
              "story",
              "reels",
              "explore_home"
          ]
      },
      "video_label": {
          "name": "ig_story_vid_label"
      },
      "body_label": {
          "name": "body_copy_label"
      },
      "title_label": {
          "name": "title_copy_label"
      }
  },
  {
      "customization_spec": {
          "publisher_platforms": [
              "instagram"
          ],
          "instagram_positions": [
              "stream",
              "explore",
              "profile_feed",
              "ig_search"
          ]
      },
      "video_label": {
          "name": "ig_feed_vid_label"
      },
      "body_label": {
          "name": "body_copy_label"
      },
      "title_label": {
          "name": "title_copy_label"
      }
  },
  {
      "customization_spec": {
          "publisher_platforms": [
              "facebook"
          ],
          "facebook_positions": [
              "feed",
              "instream_video",
              "facebook_reels_overlay",
              "marketplace",
              "video_feeds",
              "profile_feed",
              "right_hand_column",
              "search"
          ]
      },
      "video_label": {
          "name": "fb_feed_vid_label"
      },
      "body_label": {
          "name": "body_copy_label"
      },
      "title_label": {
          "name": "title_copy_label"
      }
  },
  {
      "customization_spec": {
          "publisher_platforms": [
              "facebook"
          ],
          "facebook_positions": [
              "story",
              "facebook_reels"
          ]
      },
      "video_label": {
          "name": "fb_story_vid_label"
      },
      "body_label": {
          "name": "body_copy_label"
      },
      "title_label": {
          "name": "title_copy_label"
      }
  }
]

/**
 * Create payload for multi-placement image ad creative.
 *
 * @param {Object} params
 * @param {string} params.name - Name of the ad creative.
 * @param {Array} params.bodies - Array of body objects.
 * @param {Array} params.titles - Array of title objects.
 * @param {string} params.pageId - Facebook page id.
 * @param {string} params.instagramActorId - Instagram actor id.
 * @param {Array} params.creatives - Array of creative objects from the ad.
 *        Each creative is expected to contain at least a property for
 *        videoId (facebookVideoId) or a URL and thumbnails.
 * @param {string} params.callToActionType - Call to action type.
 * @param {string} params.callToActionLink - Call to action link.
 *
 * @returns {Object} - JSON payload to create an image ad creative.
 */
export function createMultiPlacementVideoAdCreativePayload({
  name,
  bodies,
  titles,
  pageId,
  instagramActorId,
  creatives,
  callToActionType,
  callToActionLink,
  trackingTemplate=null,
  deepLink=null,
  creativeMapVideoIds=null
}) {

  let images = []
  let videos = []
  const ad_formats = ["SINGLE_VIDEO"]

  // Loop through the creatives array
  for (let i = 0; i < creatives.length; i++) {
    const creative = creatives[i];
    let videoId = null;
    if (creative.facebookVideoId) {
      videoId = creative.facebookVideoId
    }
    if (Object.keys(creativeMapVideoIds).length > 0 && creativeMapVideoIds[creative._id]) {
      videoId = creativeMapVideoIds[creative._id]
    }
     
    if (!videoId) {
      console.error("No videoId found for creative:", creative)
      continue;
    }

    // Add multiple elements based on a condition
    if (creative.isSquare) {
      videos.push({
        adlabels: [{ name: "fb_feed_vid_label" }],
        video_id: videoId
      });
      videos.push({
        adlabels: [{ name: "ig_feed_vid_label" }],
        video_id: videoId
      });
    }
    else {
      videos.push({
        adlabels: [{ name: "fb_story_vid_label" }],
        video_id: videoId
      });
      videos.push({
        adlabels: [{ name: "ig_story_vid_label" }],
        video_id: videoId
      });
    }
  }
  console.log("len of videos:", videos.length)

  // Create the payload
  let payload = {
    name: name,
    ...(trackingTemplate && { url_tags: trackingTemplate }),
    object_story_spec: {
      page_id: pageId,
      instagram_user_id: instagramActorId,
    },

    degrees_of_freedom_spec: DEGREES_OF_FREEDOM_SPEC,

    asset_feed_spec: {
      images,
      videos,
      bodies,
      titles,
      call_to_action_types: [callToActionType],
      link_urls: [
        {
          website_url: callToActionLink,
          display_url: callToActionLink,
          ...(deepLink && { deeplink_url: deepLink }),
        },
      ],
      ad_formats,
      // asset_customization_rules: getAssetCustomizationRules(ad),
      asset_customization_rules: videoCustomizationRules,
    },
  }  
  return payload;
}